import { jsx as _jsx } from "react/jsx-runtime";
import { ICONS } from '../icons.generated';
import { knotenBereinigen } from '../symbol';
const gemeldet = new Set();
/**
 * Lucide-Icon als Inline-SVG mit `stroke: currentColor` (Designsystem, Iconografie):
 * erbt die Textfarbe, ist nie bunt. Reihenfolge: eigenes Symbol (`knoten`) → Name aus
 * dem Satz → Platzhalter. Unbekannte Namen zeigen einen gestrichelten Kreis statt nichts —
 * ein Loch in der Navigation fällt schlechter auf als ein Platzhalter.
 */
export function Icon({ name, knoten, size, label, className, ...rest }) {
    let node = (knoten === undefined ? null : knotenBereinigen(knoten)) ?? ICONS[name];
    if (!node) {
        if (!gemeldet.has(name)) {
            gemeldet.add(name);
            console.warn(`[@one/ui] Icon „${name}" ist nicht im ONE-Icon-Set (packages/ui/scripts/icons.mjs).`);
        }
        node = ICONS['circle-dashed'];
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: className ? `one-icon ${className}` : 'one-icon', "data-size": size, role: label ? 'img' : undefined, "aria-label": label, "aria-hidden": label ? undefined : true, focusable: "false", ...rest, children: node.map(([tag, attrs], i) => {
            const Tag = tag;
            return _jsx(Tag, { ...attrs }, i);
        }) }));
}
/** Alle Icon-Namen, die ONE ausliefert. */
export const iconNames = Object.keys(ICONS);
